<h1 class="page-title">Programok</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/istentiszteletek']">Istentiszteletek</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/gyerekfogi']">Gyermek foglalkozások</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/ifi']">Ifjúsági alkalmak</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/hazasrandi']">Házasoknak</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/hazicsoportok']">Házicsoportok</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/programok/taborok']">Táborok, konferenciák</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/programs/programs.component.html